import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import NRADetails from './section-components/nra-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const NRA = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>NRA CET Coaching in Chennai | Bank, Railway, SSC Exams | MIET</title>
            <meta name="description" content="MIET one of the best coaching institutes for CET, Bank, SSC Exams Coaching Chennai. Offer full time/part time coaching to help students achieve their goals." />
        </Helmet>
        <PageHeader headertitle="NRA CET"  />
        <NRADetails />
        <Footer />
    </div>
}

export default NRA